import React from 'react';
import { Link } from 'gatsby'
import classNames from 'classnames'
import { RightArrow, LeftArrow } from '@cleartrip/bento-icons/src/components/Icons'

import {
  Spacer,
  Divider
} from '@cleartrip/bento/lib'


const Pagination = (props) => {
  const { docName, menus } = props;

  let arrangedMenus = Object.values(menus)
  arrangedMenus = Array.prototype.concat.apply([], arrangedMenus);
  
  const currentPage = arrangedMenus.findIndex(menuItem => menuItem.name === docName)

  const isLast = currentPage === arrangedMenus.length - 1
  const isFirst = currentPage === 0

  const prevPage = arrangedMenus[currentPage - 1]
  const nextPage = arrangedMenus[currentPage + 1]

  const linkClass = classNames(
    'td-none',
    'c-pointer',
    'c-secondary-500',
    'fs-3',
    'hover:td-underline',
    'fw-500'
  )

  return (
    <>
    <Spacer my={15} py={15}/>
    <Divider />

    <div className='flex flex-between py-9'>
        <div className="flex-1">
            {!isFirst && prevPage && prevPage.route !== 'undefined' && prevPage.route !== null &&
              <Link
                className={linkClass}
                to={prevPage.route}
              >
                <span className="va-text-bottom flex-inline"><LeftArrow className="mr-2" height={16} width={16} /> </span>Back to: {prevPage.name}
              </Link>
            }
        </div>
        <div className="flex-1 ta-right">
        {!isLast &&
          <Link
            className={linkClass}
            to={nextPage.route}
          >
            See next: {nextPage.name}<span className="va-text-bottom flex-inline pl-2"><RightArrow height={16} width={18} /></span>
          </Link>
        }
        </div>
    </div>
    </>
  );
}

export default Pagination;